import { createSelector } from '@ngrx/store';
import { getOrderTypeId } from '../../../collectionType/selectors';
import { getOnlineMenuVirtualLocationsFiltered } from '../getOnlineMenuVirtualLocationsFiltered';
import * as Utils from '@shared/core/utils';
import * as Statics from '@shared/core/statics';

export const getOnlineMenuVirtualLocationsPagesFiltered = createSelector(
    getOnlineMenuVirtualLocationsFiltered,
    getOrderTypeId,
    (onlineMenuVirtualLocationsFiltered, orderTypeId) =>
        onlineMenuVirtualLocationsFiltered
            ?.filter((virtualLocation) => virtualLocation.orderTypeId === orderTypeId)
            .reduce((allPages, virtualLocation) => {
                const displayUnavailableProducts = new Statics.ConfigStatic().current?.onlineMenu?.displayUnavailableProducts;

                if (virtualLocation.data?.Pages) {
                    const pages = displayUnavailableProducts ? virtualLocation.data.Pages : Utils.Products.getPagesWithAvailableOrNoProducts(virtualLocation.data.Pages);

                    const extendProductsPages = pages.map((page) => ({
                        ...page,
                        Products: page.Products.map((product) => ({ ...product, VirtualLocationNo: virtualLocation.virtualLocationNo })),
                    }));

                    return [...allPages, ...extendProductsPages];
                }

                return displayUnavailableProducts ? allPages : Utils.Products.getPagesWithAvailableOrNoProducts(allPages);
            }, [] as OLO.DTO.OnlineMenuPageResponseModel[]) || null,
);
